import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchMarkets(id) {
    return fetch(`${API_URL}/api/profile_market/${id}`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
